// Container editors share this check for block insertion and clipboard pasting.
export const hasSections = (data) =>
  Object.values(data.blocks || {}).some((block) => block['@type'] === 'group');
